import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SocialLinksComponent } from './social-links.component';

@NgModule({
  declarations: [SocialLinksComponent],
  imports: [CommonModule],
  exports: [SocialLinksComponent],
})
export class SocialLinksModule {}
